import React from "react";
import { connect } from "react-redux";
import { getWindow } from "ssr-window";

import { api } from "@/utils/api";
import { getCompanyInfo as getCompanyInfoDispatch } from "@/models/user";
import { setUrlParameter, getUrlParameter } from "@/utils";
import ArticleItem from "@/react-components/ArticleItem";
import EmptyResult from "@/react-components/EmptyResult";
/* import CompanyHeader from "@/react-components/CompanyHeader"; */
import Pagination from "@/react-components/Pagination";
import BackButton from "@/react-components/BackButton";

class MypageResearchInfoSection extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = getUrlParameter(props?.router?.location?.search);
    this.state = {
      pageParams: {
        pageNo: getWindow()?.history?.state?.params?.pageNo || 1,
        pageSize: 10,
        totalPage: 1,
        catagoryID:
          getWindow()?.history?.state?.params?.catagoryID ||
          props?.router?.location?.state?.category?.id ||
          urlParams?.catagoryID,
      },
      // 検索結果の保存
      articles: undefined,
      catagoryName:
        getWindow()?.history?.state?.params?.catagoryName ||
        props?.router?.location?.state?.category?.text ||
        decodeURIComponent(urlParams?.catagoryName),
      emptyText:
        getWindow()?.history?.state?.params?.emptyText ||
        props?.router?.location?.state?.emptyText,
    };
  }

  componentDidMount() {
    const { getCompanyInfo } = this.props;
    getCompanyInfo();
  }

  componentDidUpdate(prevProps) {
    const { companyInfo } = this.props;
    if (prevProps.companyInfo !== companyInfo) {
      this.fetchData();
    }
  }

  fetchData = () => {
    const { companyInfo } = this.props;
    const { pageParams, catagoryName, emptyText } = this.state;
    const state = getWindow()?.history?.state || {};
    state.params = { ...pageParams, catagoryName, emptyText };
    getWindow().history.replaceState(state, "");
    api.mypage
      .getList(
        {
          catagoryID: pageParams.catagoryID,
          pageIndex: pageParams.pageNo,
          pageSize: pageParams.pageSize,
        },
        { tagIds: JSON.stringify(companyInfo || "") }
      )
      .then((response) => {
        pageParams.totalPage = parseInt(
          (response.totalCount + pageParams.pageSize - 1) / pageParams.pageSize
        );
        this.setState({
          pageParams,
          articles: response.list,
        });
        if (response.list.length === 0) {
          setUrlParameter({ type: "noResult" });
        } else {
          setUrlParameter({
            page: pageParams.pageNo,
            catagoryID: pageParams.catagoryID,
            catagoryName: catagoryName
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  pageChange = (page) => {
    const { pageParams } = this.state;
    pageParams.pageNo = page;
    this.setState({ pageParams }, () => {
      this.fetchData();
    });
  };

  render() {
    const {
      articles,
      pageParams: { totalPage, pageNo },
      catagoryName,
      emptyText,
    } = this.state;
    return (
      <section className="my-page-research-info-section-container">
        {/* <CompanyHeader /> */}
        <BackButton />
        <h3 className="page-title-text page-title">{catagoryName}</h3>
        {articles && (
          <React.Fragment>
            {/* 検索結果 */}
            <div className="section-content">
              {articles.map((item, index) => (
                <ArticleItem key={index} articles={item} />
              ))}
            </div>
            {/* 改ページ */}
            {articles.length > 0 ? (
              <div className="pagination-container">
                <Pagination
                  totalPage={totalPage}
                  pageIndex={pageNo}
                  onChange={this.pageChange}
                />
              </div>
            ) : (
              // 検索結果なし
              <EmptyResult text={emptyText} />
            )}
          </React.Fragment>
        )}
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyInfo: state?.user?.companyInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCompanyInfo: () => dispatch(getCompanyInfoDispatch()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MypageResearchInfoSection);
